<template>
	<div class="container">
		<el-tabs v-model="activeName">
			<el-tab-pane label="系统接口配置" name="0"><System /></el-tab-pane>
			<el-tab-pane label="供应商接口配置" name="1"></el-tab-pane>
			<el-tab-pane label="分销渠道接口配置" name="2"></el-tab-pane>
			<el-tab-pane label="其他接口设置" name="3"></el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import System from './system'
export default {
	components: { System },
	data() {
		return {
			activeName: '0'
		}
	},
	created() {},
	methods: {}
}
</script>

<style lang="scss" scoped>
.container {
	padding: 0 20px;
	background-color: #fff;
}
</style>
